import { StatusPopupConfig } from '../components/status-popup/status-popup.component';
const CONTROL_TOWER_PREFIX = '[Control Tower]';

export class ShowActionStatusPopup {
  static readonly type = `${CONTROL_TOWER_PREFIX} Show Action Status Popup`;
  constructor(
    public title: string,
    public type: 'success' | 'error',
    public config?: StatusPopupConfig
  ) {}
}

export class SetControlTowerId {
  static readonly type = `${CONTROL_TOWER_PREFIX} Set Control Tower ID`;
  constructor(public controlTowerId: string) {}
}

export class SetControlTowerContext {
  static readonly type = `${CONTROL_TOWER_PREFIX} Set Control Tower Context`;
  constructor(public controlTowerId: string) {}
}

export class ClearControlTowerContext {
  static readonly type = `${CONTROL_TOWER_PREFIX} Clear Control Tower Context`;
}

export class ListenForControlTowerEntityUpdates {
  static readonly type = `${CONTROL_TOWER_PREFIX} Listen For Entity Updates`;
  constructor(
    public controlTowerId: string,
    public orgId?: string
  ) {}
}

export class StopListeningForControlTowerEntityUpdates {
  static readonly type = `${CONTROL_TOWER_PREFIX} Stop Listening For Entity Updates`;
}

export class FetchParentControlTowerIdAndContractPartiesByControlTowerId {
  static readonly type = `${CONTROL_TOWER_PREFIX} Fetch Parent Control Tower ID and Contract Parties by Control Tower ID`;
  constructor(public controlTowerId: string) {}
}

export class SetTaskFeedReadOnly {
  static readonly type = `${CONTROL_TOWER_PREFIX} Set Task Feed Read Only`;
  constructor(public isTaskFeedReadOnly: boolean) {}
}

export class FetchCurrentCollaboratorsWithPagination {
  static readonly type = `${CONTROL_TOWER_PREFIX} Fetch Current Collaborators With Pagination`;
  constructor(
    public controlTowerId: string,
    public offset: number = 0,
    public limit: number = 10,
    public searchKey?: string,
    public collaboratorType?: string,
    public role?: string,
    public verified?: boolean,
    public sortBy: string = 'createdAt',
    public sortOrder: 'asc' | 'desc' = 'desc',
    public sortByProfilePhotosFirst: boolean = false
  ) {}
}

export class SetIsCollaborator {
  static readonly type = `${CONTROL_TOWER_PREFIX} Set Is Collaborator`;
  constructor(public isCollaborator: boolean) {}
}

export class UpdateCollaboratorFeatureMarketingMetaData {
  static readonly type = `${CONTROL_TOWER_PREFIX} Update Collaborator Feature Marketing Meta Data`;
  constructor(
    public collaboratorId: string,
    public featureMarketingMetaData: { isCTAcompleted: boolean }
  ) {}
}
